// (()=>{var t={1337(t,e,r){var n=r(7501).default;function o(){"use strict";t.exports=o=function(){return e},t.exports.__esModule=!0,t.exports.default=t.exports;var e={},r=Object.prototype,i=r.hasOwnProperty,a=Object.defineProperty||function(t,e,r){t[e]=r.value},c="function"==typeof Symbol?Symbol:{},u=c.iterator||"@@iterator",s=c.asyncIterator||"@@asyncIterator",l=c.toStringTag||"@@toStringTag";function f(t,e,r){return Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}),t[e]}try{f({},"")}catch(h){f=function(t,e,r){return t[e]=r}}function p(t,e,r,n){var o,i,c,u,s=Object.create((e&&e.prototype instanceof v?e:v).prototype);return a(s,"_invoke",{value:(o=t,i=r,c=new P(n||[]),u="suspendedStart",function(t,e){if("executing"===u)throw Error("Generator is already running");if("completed"===u){if("throw"===t)throw e;return C()}for(c.method=t,c.arg=e;;){var r=c.delegate;if(r){var n=F(r,c);if(n){if(n===y)continue;return n}}if("next"===c.method)c.sent=c._sent=c.arg;else if("throw"===c.method){if("suspendedStart"===u)throw u="completed",c.arg;c.dispatchException(c.arg)}else"return"===c.method&&c.abrupt("return",c.arg);u="executing";var a=d(o,i,c);if("normal"===a.type){if(u=c.done?"completed":"suspendedYield",a.arg===y)continue;return{value:a.arg,done:c.done}}"throw"===a.type&&(u="completed",c.method="throw",c.arg=a.arg)}})}),s}function d(t,e,r){try{return{type:"normal",arg:t.call(e,r)}}catch(n){return{type:"throw",arg:n}}}e.wrap=p;var y={};function v(){}function m(){}function g(){}var w={};f(w,u,function(){return this});var x=Object.getPrototypeOf,b=x&&x(x(k([])));b&&b!==r&&i.call(b,u)&&(w=b);var $=g.prototype=v.prototype=Object.create(w);function L(t){["next","throw","return"].forEach(function(e){f(t,e,function(t){return this._invoke(e,t)})})}function E(t,e){var r;a(this,"_invoke",{value:function(o,a){function c(){return new e(function(r,c){!function r(o,a,c,u){var s=d(t[o],t,a);if("throw"!==s.type){var l=s.arg,f=l.value;return f&&"object"==n(f)&&i.call(f,"__await")?e.resolve(f.__await).then(function(t){r("next",t,c,u)},function(t){r("throw",t,c,u)}):e.resolve(f).then(function(t){l.value=t,c(l)},function(t){return r("throw",t,c,u)})}u(s.arg)}(o,a,r,c)})}return r=r?r.then(c,c):c()}})}function F(t,e){var r=e.method,n=t.iterator[r];if(void 0===n)return e.delegate=null,"throw"===r&&t.iterator.return&&(e.method="return",e.arg=void 0,F(t,e),"throw"===e.method)||"return"!==r&&(e.method="throw",e.arg=TypeError("The iterator does not provide a '"+r+"' method")),y;var o=d(n,t.iterator,e.arg);if("throw"===o.type)return e.method="throw",e.arg=o.arg,e.delegate=null,y;var i=o.arg;return i?i.done?(e[t.resultName]=i.value,e.next=t.nextLoc,"return"!==e.method&&(e.method="next",e.arg=void 0),e.delegate=null,y):i:(e.method="throw",e.arg=TypeError("iterator result is not an object"),e.delegate=null,y)}function _(t){var e={tryLoc:t[0]};1 in t&&(e.catchLoc=t[1]),2 in t&&(e.finallyLoc=t[2],e.afterLoc=t[3]),this.tryEntries.push(e)}function S(t){var e=t.completion||{};e.type="normal",delete e.arg,t.completion=e}function P(t){this.tryEntries=[{tryLoc:"root"}],t.forEach(_,this),this.reset(!0)}function k(t){if(t){var e=t[u];if(e)return e.call(t);if("function"==typeof t.next)return t;if(!isNaN(t.length)){var r=-1,n=function e(){for(;++r<t.length;)if(i.call(t,r))return e.value=t[r],e.done=!1,e;return e.value=void 0,e.done=!0,e};return n.next=n}}return{next:C}}function C(){return{value:void 0,done:!0}}return m.prototype=g,a($,"constructor",{value:g,configurable:!0}),a(g,"constructor",{value:m,configurable:!0}),m.displayName=f(g,l,"GeneratorFunction"),e.isGeneratorFunction=function(t){var e="function"==typeof t&&t.constructor;return!!e&&(e===m||"GeneratorFunction"===(e.displayName||e.name))},e.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,g):(t.__proto__=g,f(t,l,"GeneratorFunction")),t.prototype=Object.create($),t},e.awrap=function(t){return{__await:t}},L(E.prototype),f(E.prototype,s,function(){return this}),e.AsyncIterator=E,e.async=function(t,r,n,o,i){void 0===i&&(i=Promise);var a=new E(p(t,r,n,o),i);return e.isGeneratorFunction(r)?a:a.next().then(function(t){return t.done?t.value:a.next()})},L($),f($,l,"Generator"),f($,u,function(){return this}),f($,"toString",function(){return"[object Generator]"}),e.keys=function(t){var e=Object(t),r=[];for(var n in e)r.push(n);return r.reverse(),function t(){for(;r.length;){var n=r.pop();if(n in e)return t.value=n,t.done=!1,t}return t.done=!0,t}},e.values=k,P.prototype={constructor:P,reset:function(t){if(this.prev=0,this.next=0,this.sent=this._sent=void 0,this.done=!1,this.delegate=null,this.method="next",this.arg=void 0,this.tryEntries.forEach(S),!t)for(var e in this)"t"===e.charAt(0)&&i.call(this,e)&&!isNaN(+e.slice(1))&&(this[e]=void 0)},stop:function(){this.done=!0;var t=this.tryEntries[0].completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(t){if(this.done)throw t;var e=this;function r(r,n){return a.type="throw",a.arg=t,e.next=r,n&&(e.method="next",e.arg=void 0),!!n}for(var n=this.tryEntries.length-1;n>=0;--n){var o=this.tryEntries[n],a=o.completion;if("root"===o.tryLoc)return r("end");if(o.tryLoc<=this.prev){var c=i.call(o,"catchLoc"),u=i.call(o,"finallyLoc");if(c&&u){if(this.prev<o.catchLoc)return r(o.catchLoc,!0);if(this.prev<o.finallyLoc)return r(o.finallyLoc)}else if(c){if(this.prev<o.catchLoc)return r(o.catchLoc,!0)}else{if(!u)throw Error("try statement without catch or finally");if(this.prev<o.finallyLoc)return r(o.finallyLoc)}}}},abrupt:function(t,e){for(var r=this.tryEntries.length-1;r>=0;--r){var n=this.tryEntries[r];if(n.tryLoc<=this.prev&&i.call(n,"finallyLoc")&&this.prev<n.finallyLoc){var o=n;break}}o&&("break"===t||"continue"===t)&&o.tryLoc<=e&&e<=o.finallyLoc&&(o=null);var a=o?o.completion:{};return a.type=t,a.arg=e,o?(this.method="next",this.next=o.finallyLoc,y):this.complete(a)},complete:function(t,e){if("throw"===t.type)throw t.arg;return"break"===t.type||"continue"===t.type?this.next=t.arg:"return"===t.type?(this.rval=this.arg=t.arg,this.method="return",this.next="end"):"normal"===t.type&&e&&(this.next=e),y},finish:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.finallyLoc===t)return this.complete(r.completion,r.afterLoc),S(r),y}},catch:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.tryLoc===t){var n=r.completion;if("throw"===n.type){var o=n.arg;S(r)}return o}}throw Error("illegal catch attempt")},delegateYield:function(t,e,r){return this.delegate={iterator:k(t),resultName:e,nextLoc:r},"next"===this.method&&(this.arg=void 0),y}},e}t.exports=o,t.exports.__esModule=!0,t.exports.default=t.exports},7501(t){function e(r){return t.exports=e="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},t.exports.__esModule=!0,t.exports.default=t.exports,e(r)}t.exports=e,t.exports.__esModule=!0,t.exports.default=t.exports},824(t,e,r){var n=r(1337)();t.exports=n;try{regeneratorRuntime=n}catch(o){"object"==typeof globalThis?globalThis.regeneratorRuntime=n:Function("r","regeneratorRuntime = r")(n)}}},e={};function r(n){var o=e[n];if(void 0!==o)return o.exports;var i=e[n]={exports:{}};return t[n](i,i.exports,r),i.exports}r.n=t=>{var e=t&&t.__esModule?()=>t.default:()=>t;return r.d(e,{a:e}),e},r.d=(t,e)=>{for(var n in e)r.o(e,n)&&!r.o(t,n)&&Object.defineProperty(t,n,{enumerable:!0,get:e[n]})},r.o=(t,e)=>Object.prototype.hasOwnProperty.call(t,e),(()=>{"use strict";function t(t,e,r,n,o,i,a){try{var c=t[i](a),u=c.value}catch(s){return void r(s)}c.done?e(u):Promise.resolve(u).then(n,o)}function e(e){return function(){var r=this,n=arguments;return new Promise(function(o,i){var a=e.apply(r,n);function c(e){t(a,o,i,c,u,"next",e)}function u(e){t(a,o,i,c,u,"throw",e)}c(void 0)})}}function n(t,e){if(!(t instanceof e))throw TypeError("Cannot call a class as a function")}function o(t){return(o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function i(t){var e=function(t,e){if("object"!==o(t)||null===t)return t;var r=t[Symbol.toPrimitive];if(void 0!==r){var n=r.call(t,e||"default");if("object"!==o(n))return n;throw TypeError("@@toPrimitive must return a primitive value.")}return("string"===e?String:Number)(t)}(t,"string");return"symbol"===o(e)?e:String(e)}function a(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,i(n.key),n)}}function c(t,e,r){return e&&a(t.prototype,e),r&&a(t,r),Object.defineProperty(t,"prototype",{writable:!1}),t}function u(t){if(void 0===t)throw ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function s(t,e){return(s=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function l(t,e){if("function"!=typeof e&&null!==e)throw TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&s(t,e)}function f(t){return(f=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function h(t,e,r){return(h=!function(){if("undefined"==typeof Reflect||!Reflect.construct||Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}()?function(t,e,r){var n=[null];n.push.apply(n,e);var o=new(Function.bind.apply(t,n));return r&&s(o,r.prototype),o}:Reflect.construct.bind()).apply(null,arguments)}function p(t){var e="function"==typeof Map?new Map:void 0;return(p=function(t){var r;if(null===t||(r=t,-1===Function.toString.call(r).indexOf("[native code]")))return t;if("function"!=typeof t)throw TypeError("Super expression must either be null or a function");if(void 0!==e){if(e.has(t))return e.get(t);e.set(t,n)}function n(){return h(t,arguments,f(this).constructor)}return n.prototype=Object.create(t.prototype,{constructor:{value:n,enumerable:!1,writable:!0,configurable:!0}}),s(n,t)})(t)}var d=r(824),y=r.n(d);function v(t){var e=function(){if("undefined"==typeof Reflect||!Reflect.construct||Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var r,n=f(t);if(e){var i=f(this).constructor;r=Reflect.construct(n,arguments,i)}else r=n.apply(this,arguments);return function(t,e){if(e&&("object"===o(e)||"function"==typeof e))return e;if(void 0!==e)throw TypeError("Derived constructors may only return object or undefined");return u(t)}(this,r)}}var m=function(t){l(a,t);var r,o,i=v(a);function a(){n(this,a),t=i.call(this);var t,e=new URL(window.location.href);return t.sortBy=e.searchParams.get("sort_by"),t.sectionId=t.closest(".shopify-section").id.replace("shopify-section-",""),t.productsContainer=document.querySelector("[data-products-container]"),t.collectionUrl=t.getAttribute("collection-url"),t.filterForm=t.querySelector("form"),t.removeFiltersElements=Array.from(t.querySelectorAll("[data-remove-filter]")),t.formChangeFunction=t.formChange.bind(u(t)),t.filterForm.addEventListener("change",t.formChangeFunction),t.removeFilterFunction=t.removeFilter.bind(u(t)),t.removeFiltersElements.forEach(function(e){e.addEventListener("click",t.removeFilterFunction)}),t}return c(a,[{key:"disconnectedCallback",value:function(){var t=this;this.filterForm.removeEventListener("change",this.formChangeFunction),this.removeFiltersElements.forEach(function(e){e.removeEventListener("click",t.removeFilterFunction)})}},{key:"formChange",value:(o=e(y().mark(function t(){var e;return y().wrap(function(t){for(;;)switch(t.prev=t.next){case 0:this.classList.add("loading"),this.productsContainer.classList.add("loading"),e=this.buildFilterUrl(),this.fetchNewCollection(e);case 4:case"end":return t.stop()}},t,this)})),function(){return o.apply(this,arguments)})},{key:"removeFilter",value:function(t){t.preventDefault();var e=t.currentTarget,r=new URL(e.href).search.replace("?",""),n=this.buildFilterUrl(r);this.fetchNewCollection(n)}},{key:"buildFilterUrl",value:function(t){var e=new URLSearchParams(new FormData(this.filterForm));(t||""===t)&&(e=t);var r=new URL("".concat(window.location.origin).concat(this.collectionUrl,"?").concat(e));this.sortBy&&r.searchParams.set("sort_by",this.sortBy);var n=r.toString();return r.searchParams.set("section_id",this.sectionId),{filtersUrl:n,sectionRenderingUrl:r.toString()}}},{key:"fetchNewCollection",value:(r=e(y().mark(function t(e){var r,n,o,i,a;return y().wrap(function(t){for(;;)switch(t.prev=t.next){case 0:return r=e.sectionRenderingUrl,n=e.filtersUrl,t.next=3,fetch(r);case 3:return o=t.sent,t.next=6,o.text();case 6:i=t.sent,window.history.pushState(null,null,n),a=(new DOMParser).parseFromString(i,"text/html"),Array.from(this.querySelectorAll("details[open]")).forEach(function(t){a.querySelector("details[id='".concat(t.id,"']")).setAttribute("open","")}),this.parentElement.innerHTML=a.querySelector("collection-filters").parentElement.innerHTML,this.productsContainer.innerHTML=a.querySelector("[data-products-container]").innerHTML,document.querySelector(".collection__products").classList.remove("loading");case 13:case"end":return t.stop()}},t,this)})),function(t){return r.apply(this,arguments)})}]),a}(p(HTMLElement));try{customElements.define("collection-filters",m)}catch(g){console.log("collection-filters already defined",g)}var w=function(t){l(i,t);var r,o=v(i);function i(){var t;return n(this,i),(t=o.call(this)).productsContainer=document.querySelector("[data-products-container]"),t.select=t.querySelector("select"),t.select.addEventListener("change",t.selectChange.bind(u(t))),t}return c(i,[{key:"selectChange",value:(r=e(y().mark(function t(){var e,r,n,o,i;return y().wrap(function(t){for(;;)switch(t.prev=t.next){case 0:return e=this.buildNewUrl(),document.querySelector("collection-filters").sortBy=this.select.value,this.productsContainer.classList.add("loading-state"),t.next=5,fetch(e);case 5:return r=t.sent,t.next=8,r.text();case 8:n=t.sent,window.history.pushState(null,null,e),(o=document.createElement("div")).innerHTML=n,i=o.querySelector("[data-products-container]"),this.productsContainer.innerHTML=i.innerHTML,this.productsContainer.classList.remove("loading");case 15:case"end":return t.stop()}},t,this)})),function(){return r.apply(this,arguments)})},{key:"buildNewUrl",value:function(){var t=new URL(window.location.href);return t.searchParams.delete("sort_by"),t.searchParams.delete("page"),t.searchParams.append("sort_by",this.select.value),t}}]),i}(p(HTMLElement));try{customElements.define("filter-sort-by",w)}catch(x){console.log("filter-sort-by already defined",x)}})()})();


(() => {

    var t = {
            1337(t, e, r) {
                var n = r(7501).default;

                function o() {
                    "use strict";
                    t.exports = o = function() {
                        return e
                    }, t.exports.__esModule = !0, t.exports.default = t.exports;
                    var e = {},
                        r = Object.prototype,
                        i = r.hasOwnProperty,
                        a = Object.defineProperty || function(t, e, r) {
                            t[e] = r.value
                        },
                        c = "function" == typeof Symbol ? Symbol : {},
                        u = c.iterator || "@@iterator",
                        s = c.asyncIterator || "@@asyncIterator",
                        l = c.toStringTag || "@@toStringTag";

                    function f(t, e, r) {
                        return Object.defineProperty(t, e, {
                            value: r,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), t[e]
                    }
                    try {
                        f({}, "")
                    } catch (h) {
                        f = function(t, e, r) {
                            return t[e] = r
                        }
                    }

                    function p(t, e, r, n) {
                        var o, i, c, u, s = Object.create((e && e.prototype instanceof v ? e : v).prototype);
                        return a(s, "_invoke", {
                            value: (o = t, i = r, c = new P(n || []), u = "suspendedStart", function(t, e) {
                                if ("executing" === u) throw Error("Generator is already running");
                                if ("completed" === u) {
                                    if ("throw" === t) throw e;
                                    return C()
                                }
                                for (c.method = t, c.arg = e;;) {
                                    var r = c.delegate;
                                    if (r) {
                                        var n = F(r, c);
                                        if (n) {
                                            if (n === y) continue;
                                            return n
                                        }
                                    }
                                    if ("next" === c.method) c.sent = c._sent = c.arg;
                                    else if ("throw" === c.method) {
                                        if ("suspendedStart" === u) throw u = "completed", c.arg;
                                        c.dispatchException(c.arg)
                                    } else "return" === c.method && c.abrupt("return", c.arg);
                                    u = "executing";
                                    var a = d(o, i, c);
                                    if ("normal" === a.type) {
                                        if (u = c.done ? "completed" : "suspendedYield", a.arg === y) continue;
                                        return {
                                            value: a.arg,
                                            done: c.done
                                        }
                                    }
                                    "throw" === a.type && (u = "completed", c.method = "throw", c.arg = a.arg)
                                }
                            })
                        }), s
                    }

                    function d(t, e, r) {
                        try {
                            return {
                                type: "normal",
                                arg: t.call(e, r)
                            }
                        } catch (n) {
                            return {
                                type: "throw",
                                arg: n
                            }
                        }
                    }
                    e.wrap = p;
                    var y = {};

                    function v() {}

                    function m() {}

                    function g() {}
                    var w = {};
                    f(w, u, function() {
                        return this
                    });
                    var x = Object.getPrototypeOf,
                        b = x && x(x(k([])));
                    b && b !== r && i.call(b, u) && (w = b);
                    var $ = g.prototype = v.prototype = Object.create(w);

                    function L(t) {
                        ["next", "throw", "return"].forEach(function(e) {
                            f(t, e, function(t) {
                                return this._invoke(e, t)
                            })
                        })
                    }

                    function E(t, e) {
                        var r;
                        a(this, "_invoke", {
                            value: function(o, a) {
                                function c() {
                                    return new e(function(r, c) {
                                        ! function r(o, a, c, u) {
                                            var s = d(t[o], t, a);
                                            if ("throw" !== s.type) {
                                                var l = s.arg,
                                                    f = l.value;
                                                return f && "object" == n(f) && i.call(f, "__await") ? e.resolve(f.__await).then(function(t) {
                                                    r("next", t, c, u)
                                                }, function(t) {
                                                    r("throw", t, c, u)
                                                }) : e.resolve(f).then(function(t) {
                                                    l.value = t, c(l)
                                                }, function(t) {
                                                    return r("throw", t, c, u)
                                                })
                                            }
                                            u(s.arg)
                                        }(o, a, r, c)
                                    })
                                }
                                return r = r ? r.then(c, c) : c()
                            }
                        })
                    }

                    function F(t, e) {
                        var r = e.method,
                            n = t.iterator[r];
                        if (void 0 === n) return e.delegate = null, "throw" === r && t.iterator.return && (e.method = "return", e.arg = void 0, F(t, e), "throw" === e.method) || "return" !== r && (e.method = "throw", e.arg = TypeError("The iterator does not provide a '" + r + "' method")), y;
                        var o = d(n, t.iterator, e.arg);
                        if ("throw" === o.type) return e.method = "throw", e.arg = o.arg, e.delegate = null, y;
                        var i = o.arg;
                        return i ? i.done ? (e[t.resultName] = i.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, y) : i : (e.method = "throw", e.arg = TypeError("iterator result is not an object"), e.delegate = null, y)
                    }

                    function _(t) {
                        var e = {
                            tryLoc: t[0]
                        };
                        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e)
                    }

                    function S(t) {
                        var e = t.completion || {};
                        e.type = "normal", delete e.arg, t.completion = e
                    }

                    function P(t) {
                        this.tryEntries = [{
                            tryLoc: "root"
                        }], t.forEach(_, this), this.reset(!0)
                    }

                    function k(t) {
                        if (t) {
                            var e = t[u];
                            if (e) return e.call(t);
                            if ("function" == typeof t.next) return t;
                            if (!isNaN(t.length)) {
                                var r = -1,
                                    n = function e() {
                                        for (; ++r < t.length;)
                                            if (i.call(t, r)) return e.value = t[r], e.done = !1, e;
                                        return e.value = void 0, e.done = !0, e
                                    };
                                return n.next = n
                            }
                        }
                        return {
                            next: C
                        }
                    }

                    function C() {
                        return {
                            value: void 0,
                            done: !0
                        }
                    }
                    return m.prototype = g, a($, "constructor", {
                        value: g,
                        configurable: !0
                    }), a(g, "constructor", {
                        value: m,
                        configurable: !0
                    }), m.displayName = f(g, l, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
                        var e = "function" == typeof t && t.constructor;
                        return !!e && (e === m || "GeneratorFunction" === (e.displayName || e.name))
                    }, e.mark = function(t) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(t, g) : (t.__proto__ = g, f(t, l, "GeneratorFunction")), t.prototype = Object.create($), t
                    }, e.awrap = function(t) {
                        return {
                            __await: t
                        }
                    }, L(E.prototype), f(E.prototype, s, function() {
                        return this
                    }), e.AsyncIterator = E, e.async = function(t, r, n, o, i) {
                        void 0 === i && (i = Promise);
                        var a = new E(p(t, r, n, o), i);
                        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
                            return t.done ? t.value : a.next()
                        })
                    }, L($), f($, l, "Generator"), f($, u, function() {
                        return this
                    }), f($, "toString", function() {
                        return "[object Generator]"
                    }), e.keys = function(t) {
                        var e = Object(t),
                            r = [];
                        for (var n in e) r.push(n);
                        return r.reverse(),
                            function t() {
                                for (; r.length;) {
                                    var n = r.pop();
                                    if (n in e) return t.value = n, t.done = !1, t
                                }
                                return t.done = !0, t
                            }
                    }, e.values = k, P.prototype = {
                        constructor: P,
                        reset: function(t) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(S), !t)
                                for (var e in this) "t" === e.charAt(0) && i.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0)
                        },
                        stop: function() {
                            this.done = !0;
                            var t = this.tryEntries[0].completion;
                            if ("throw" === t.type) throw t.arg;
                            return this.rval
                        },
                        dispatchException: function(t) {
                            if (this.done) throw t;
                            var e = this;

                            function r(r, n) {
                                return a.type = "throw", a.arg = t, e.next = r, n && (e.method = "next", e.arg = void 0), !!n
                            }
                            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                                var o = this.tryEntries[n],
                                    a = o.completion;
                                if ("root" === o.tryLoc) return r("end");
                                if (o.tryLoc <= this.prev) {
                                    var c = i.call(o, "catchLoc"),
                                        u = i.call(o, "finallyLoc");
                                    if (c && u) {
                                        if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                        if (this.prev < o.finallyLoc) return r(o.finallyLoc)
                                    } else if (c) {
                                        if (this.prev < o.catchLoc) return r(o.catchLoc, !0)
                                    } else {
                                        if (!u) throw Error("try statement without catch or finally");
                                        if (this.prev < o.finallyLoc) return r(o.finallyLoc)
                                    }
                                }
                            }
                        },
                        abrupt: function(t, e) {
                            for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                                var n = this.tryEntries[r];
                                if (n.tryLoc <= this.prev && i.call(n, "finallyLoc") && this.prev < n.finallyLoc) {
                                    var o = n;
                                    break
                                }
                            }
                            o && ("break" === t || "continue" === t) && o.tryLoc <= e && e <= o.finallyLoc && (o = null);
                            var a = o ? o.completion : {};
                            return a.type = t, a.arg = e, o ? (this.method = "next", this.next = o.finallyLoc, y) : this.complete(a)
                        },
                        complete: function(t, e) {
                            if ("throw" === t.type) throw t.arg;
                            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y
                        },
                        finish: function(t) {
                            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                                var r = this.tryEntries[e];
                                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), S(r), y
                            }
                        },
                        catch: function(t) {
                            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                                var r = this.tryEntries[e];
                                if (r.tryLoc === t) {
                                    var n = r.completion;
                                    if ("throw" === n.type) {
                                        var o = n.arg;
                                        S(r)
                                    }
                                    return o
                                }
                            }
                            throw Error("illegal catch attempt")
                        },
                        delegateYield: function(t, e, r) {
                            return this.delegate = {
                                iterator: k(t),
                                resultName: e,
                                nextLoc: r
                            }, "next" === this.method && (this.arg = void 0), y
                        }
                    }, e
                }
                t.exports = o, t.exports.__esModule = !0, t.exports.default = t.exports
            },
            7501(t) {
                function e(r) {
                    return t.exports = e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                        return typeof t
                    } : function(t) {
                        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
                    }, t.exports.__esModule = !0, t.exports.default = t.exports, e(r)
                }
                t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports
            },
            824(t, e, r) {
                var n = r(1337)();
                t.exports = n;
                try {
                    regeneratorRuntime = n
                } catch (o) {
                    "object" == typeof globalThis ? globalThis.regeneratorRuntime = n : Function("r", "regeneratorRuntime = r")(n)
                }
            }
        },
        e = {};

    function r(n) {
        var o = e[n];
        if (void 0 !== o) return o.exports;
        var i = e[n] = {
            exports: {}
        };
        return t[n](i, i.exports, r), i.exports
    }
    r.n = t => {
        var e = t && t.__esModule ? () => t.default : () => t;
        return r.d(e, {
            a: e
        }), e
    }, r.d = (t, e) => {
        for (var n in e) r.o(e, n) && !r.o(t, n) && Object.defineProperty(t, n, {
            enumerable: !0,
            get: e[n]
        })
    }, r.o = (t, e) => Object.prototype.hasOwnProperty.call(t, e), (() => {
        "use strict";

        function t(t, e, r, n, o, i, a) {
            try {
                var c = t[i](a),
                    u = c.value
            } catch (s) {
                return void r(s)
            }
            c.done ? e(u) : Promise.resolve(u).then(n, o)
        }

        function e(e) {
            return function() {
                var r = this,
                    n = arguments;
                return new Promise(function(o, i) {
                    var a = e.apply(r, n);

                    function c(e) {
                        t(a, o, i, c, u, "next", e)
                    }

                    function u(e) {
                        t(a, o, i, c, u, "throw", e)
                    }
                    c(void 0)
                })
            }
        }

        function n(t, e) {
            if (!(t instanceof e)) throw TypeError("Cannot call a class as a function")
        }

        function o(t) {
            return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
            })(t)
        }

        function i(t) {
            var e = function(t, e) {
                if ("object" !== o(t) || null === t) return t;
                var r = t[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(t, e || "default");
                    if ("object" !== o(n)) return n;
                    throw TypeError("@@toPrimitive must return a primitive value.")
                }
                return ("string" === e ? String : Number)(t)
            }(t, "string");
            return "symbol" === o(e) ? e : String(e)
        }

        function a(t, e) {
            for (var r = 0; r < e.length; r++) {
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, i(n.key), n)
            }
        }

        function c(t, e, r) {
            return e && a(t.prototype, e), r && a(t, r), Object.defineProperty(t, "prototype", {
                writable: !1
            }), t
        }

        function u(t) {
            if (void 0 === t) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t
        }

        function s(t, e) {
            return (s = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
                return t.__proto__ = e, t
            })(t, e)
        }

        function l(t, e) {
            if ("function" != typeof e && null !== e) throw TypeError("Super expression must either be null or a function");
            t.prototype = Object.create(e && e.prototype, {
                constructor: {
                    value: t,
                    writable: !0,
                    configurable: !0
                }
            }), Object.defineProperty(t, "prototype", {
                writable: !1
            }), e && s(t, e)
        }

        function f(t) {
            return (f = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
                return t.__proto__ || Object.getPrototypeOf(t)
            })(t)
        }

        function h(t, e, r) {
            return (h = ! function() {
                if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0
                } catch (t) {
                    return !1
                }
            }() ? function(t, e, r) {
                var n = [null];
                n.push.apply(n, e);
                var o = new(Function.bind.apply(t, n));
                return r && s(o, r.prototype), o
            } : Reflect.construct.bind()).apply(null, arguments)
        }

        function p(t) {
            var e = "function" == typeof Map ? new Map : void 0;
            return (p = function(t) {
                var r;
                if (null === t || (r = t, -1 === Function.toString.call(r).indexOf("[native code]"))) return t;
                if ("function" != typeof t) throw TypeError("Super expression must either be null or a function");
                if (void 0 !== e) {
                    if (e.has(t)) return e.get(t);
                    e.set(t, n)
                }

                function n() {
                    return h(t, arguments, f(this).constructor)
                }
                return n.prototype = Object.create(t.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), s(n, t)
            })(t)
        }
        var d = r(824),
            y = r.n(d);

        function v(t) {
            var e = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0
                } catch (t) {
                    return !1
                }
            }();
            return function() {
                var r, n = f(t);
                if (e) {
                    var i = f(this).constructor;
                    r = Reflect.construct(n, arguments, i)
                } else r = n.apply(this, arguments);
                return function(t, e) {
                    if (e && ("object" === o(e) || "function" == typeof e)) return e;
                    if (void 0 !== e) throw TypeError("Derived constructors may only return object or undefined");
                    return u(t)
                }(this, r)
            }
        }
        var m = function(t) {
            l(a, t);
            var r, o, i = v(a);

            function a() {
                n(this, a), t = i.call(this);
                var t, e = new URL(window.location.href);
                return t.sortBy = e.searchParams.get("sort_by"), t.sectionId = t.closest(".shopify-section").id.replace("shopify-section-", ""), t.productsContainer = document.querySelector("[data-products-container]"), t.collectionUrl = t.getAttribute("collection-url"), t.filterForm = t.querySelector("form"), t.removeFiltersElements = Array.from(t.querySelectorAll("[data-remove-filter]")), t.formChangeFunction = t.formChange.bind(u(t)), t.filterForm.addEventListener("change", t.formChangeFunction), t.removeFilterFunction = t.removeFilter.bind(u(t)), t.removeFiltersElements.forEach(function(e) {
                    e.addEventListener("click", t.removeFilterFunction)
                }), t
            }
            return c(a, [{
                key: "disconnectedCallback",
                value: function() {
                    var t = this;
                    this.filterForm.removeEventListener("change", this.formChangeFunction), this.removeFiltersElements.forEach(function(e) {
                        e.removeEventListener("click", t.removeFilterFunction)
                    })
                }
            }, {
                key: "formChange",
                value: (o = e(y().mark(function t() {
                    var e;
                    return y().wrap(function(t) {
                        for (;;) switch (t.prev = t.next) {
                            case 0:                          
                                this.productsContainer.classList.add("loading"), e = this.buildFilterUrl(), this.fetchNewCollection(e);
                            case 4:
                            case "end":
                                return t.stop()
                        }
                    }, t, this)
                })), function() {
                    return o.apply(this, arguments)
                })
            }, {
                key: "removeFilter",
                value: function(t) {
                    t.preventDefault();
                    var e = t.currentTarget,
                        r = new URL(e.href).search.replace("?", ""),
                        n = this.buildFilterUrl(r);
                    this.fetchNewCollection(n)
                }
            }, {
    key: "buildFilterUrl",
    value: function(t_formDataParams) { 
        var activeFilterParams, 
            searchPageBaseUrl,  
            currentSearchTerm, 
            finalFetchUrl,     
            urlForHistory;    

        activeFilterParams = new URLSearchParams(new FormData(this.filterForm));
        if (t_formDataParams || "" === t_formDataParams) {
            activeFilterParams = new URLSearchParams(t_formDataParams);
        }

        var mainSearchInput = document.getElementById('Search-In-Template');
        if (mainSearchInput && mainSearchInput.value && mainSearchInput.value.trim() !== '') {
            currentSearchTerm = mainSearchInput.value.trim();
        } else {
            var initialCollectionUrl = new URL(this.collectionUrl, window.location.origin);
            var qFromCollectionUrl = initialCollectionUrl.searchParams.get('q');
            if (qFromCollectionUrl && qFromCollectionUrl.trim() !== '') {
                currentSearchTerm = qFromCollectionUrl.trim();
            } else {
                currentSearchTerm = ""; 
            }
        }
        

        if (currentSearchTerm.includes('filter.') || currentSearchTerm.includes('?')) {

            console.warn('[buildFilterUrl] Le terme de recherche semble corrompu:', currentSearchTerm, "- Il ne sera pas utilisé.");
            currentSearchTerm = "";
        }


        var basePath = new URL(this.collectionUrl, window.location.origin).pathname;
        finalFetchUrl = new URL(basePath, window.location.origin);


        if (currentSearchTerm && currentSearchTerm !== "") {
            finalFetchUrl.searchParams.set('q', currentSearchTerm);
        }


        activeFilterParams.forEach(function(val, key) {
            if (key.toLowerCase() !== 'q') { // S'assurer de ne pas ajouter q depuis le formulaire de filtres
                finalFetchUrl.searchParams.append(key, val);
            }
        });


        this.sortBy && finalFetchUrl.searchParams.set("sort_by", this.sortBy);


        urlForHistory = finalFetchUrl.toString(); 
        finalFetchUrl.searchParams.set("section_id", this.sectionId); 


        return {
            filtersUrl: urlForHistory,
            sectionRenderingUrl: finalFetchUrl.toString()
        }
    }
}, {
                key: "fetchNewCollection",
                value: (r = e(y().mark(function t(e) {
                    var r, n, o, i, a;
                    return y().wrap(function(t) {
                        for (;;) switch (t.prev = t.next) {
                            case 0:
                                return r = e.sectionRenderingUrl, n = e.filtersUrl, t.next = 3, fetch(r);
                            case 3:
                                o = t.sent;                          
                                if (o && typeof o.status !== 'undefined') {
                                    console.log('[CUSTOM LOG] Actual Fetch response status from script (o.status):', o.status, o.statusText);
                                } else {
                                    console.error('[CUSTOM LOG] Variable "o" is undefined or has no status property! THIS IS THE PROBLEM.');
                                    t.stop(); 
                                    return; 
                                }                           
                                t.next = 6;
                                return o.text();
                            case 6:
                                i = t.sent,
                                  console.log('Fetched HTML content (snippet):', i.substring(0, 500) + '...');
                                  window.history.pushState(null, null, n), a = (new DOMParser).parseFromString(i, "text/html"), Array.from(this.querySelectorAll("details[open]")).forEach(function(t) {
                                    a.querySelector("details[id='".concat(t.id, "']")).setAttribute("open", "")
                                }), this.parentElement.innerHTML = a.querySelector("collection-filters").parentElement.innerHTML, this.productsContainer.innerHTML = a.querySelector("[data-products-container]").innerHTML, document.querySelector(".collection__products").classList.remove("loading");

                            case 13:
                            case "end":
                                return t.stop()
                        }
                    }, t, this)
                })), function(t) {
                    return r.apply(this, arguments)
                })
            }]), a
        }(p(HTMLElement));
        try {
            customElements.define("collection-filters", m)
        } catch (g) {
            console.log("collection-filters already defined", g)
        }
        var w = function(t) {
            l(i, t);
            var r, o = v(i);

            function i() {
                var t;
                return n(this, i), (t = o.call(this)).productsContainer = document.querySelector("[data-products-container]"), t.select = t.querySelector("select"), t.select.addEventListener("change", t.selectChange.bind(u(t))), t
            }
            return c(i, [{
                key: "selectChange",
                value: (r = e(y().mark(function t() {
                    var e, r, n, o, i;
                    return y().wrap(function(t) {
                        for (;;) switch (t.prev = t.next) {
                            case 0:
                                return e = this.buildNewUrl(), document.querySelector("collection-filters").sortBy = this.select.value, this.productsContainer.classList.add("loading-state"), t.next = 5, fetch(e);
                            case 5:
                                return r = t.sent, t.next = 8, r.text();
                            case 8:
                                n = t.sent, window.history.pushState(null, null, e), (o = document.createElement("div")).innerHTML = n, i = o.querySelector("[data-products-container]"), this.productsContainer.innerHTML = i.innerHTML, this.productsContainer.classList.remove("loading");
                            case 15:
                            case "end":
                                return t.stop()
                        }
                    }, t, this)
                })), function() {
                    return r.apply(this, arguments)
                })
            }, {
                key: "buildNewUrl",
                value: function() {
                    var t = new URL(window.location.href);
                    return t.searchParams.delete("sort_by"), t.searchParams.delete("page"), t.searchParams.append("sort_by", this.select.value), t
                }
            }]), i
        }(p(HTMLElement));
        try {
            customElements.define("filter-sort-by", w)
        } catch (x) {
            console.log("filter-sort-by already defined", x)
        }
    })()
})();